import { lazy } from "react";
import type { ElementDetails } from "@/lib/types";
import { Sizes } from "./constants";
import type { JiraIssuesProps } from "./types";

export const details = {
  name: "JiraIssues",
  description: "Displays Kanban columns and all paged issues for a Jira board",
  tags: ["Business", "Productivity", "Organization"],
  category: "Jira",
  grid: Sizes,
  gridNames: {
    default: "Medium",
    large: "Large",
  },
  integrationsUsed: ["atlassian"],
  setup: lazy(() => import("./Setup").then(m => ({ default: m.Setup }))),
  defaultProps: {},
} as ElementDetails<JiraIssuesProps>;
